import { type RefObject, useEffect } from 'react';

type Event = MouseEvent | TouchEvent;

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event) => void,
  portalSelector?: string,
) {
  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref.current;
      const target = event.target as Node;

      if (portalSelector) {
        const portalEl = document.querySelector(portalSelector);

        if (portalEl && portalEl.contains(target)) {
          return;
        }
      }

      if (!el || el.contains(target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, portalSelector]);
}
